<clr-modal clrModalSize="md" [(clrModalOpen)]="service.showResourceInfo">

        <h3 class="modal-title">{{'Forms.ResourceInfo.Title' | translate}}</h3>
        <div class="modal-body">
          <!--
            <table class="table table-noborder">
                <tr *ngIf="service.changes.at(0)">
                    <td class="left">{{ 'Misc.CreatedBy' | translate }}:</td>
                    <td class="left" *ngIf="service.changes.at(0).user_mail"><strong>
                            <cds-icon shape="user" badge="success"> </cds-icon> {{ service.changes.at(0).user_mail }}
                        </strong></td>
                    <td class="left" *ngIf="!service.changes.at(0).user_mail"><strong>
                            <cds-icon shape="host" badge="success"> </cds-icon> Server
                        </strong></td>
                    <td class="left" *ngIf="service.changes.at(0).created_at">
                        {{ 'Misc.At' | translate }} {{ service.changes.at(0).created_at | date: 'dd.MM.yyyy' }}
                    </td>
                </tr>
                <tr *ngIf="service.changes.at(-1)">
                    <td class="left">{{ 'Misc.LastChange' | translate }}:</td>
                    <td class="left" *ngIf="service.changes.at(-1).user_mail"><strong>
                            <cds-icon shape="user" badge="info"> </cds-icon> {{ service.changes.at(-1).user_mail }}
                        </strong></td>
                    <td class="left" *ngIf="!service.changes.at(-1).user_mail"><strong>
                            <cds-icon shape="host" badge="success"> </cds-icon> Server
                        </strong></td>
                    <td class="left" *ngIf="service.changes.at(-1).created_at">
                        {{ 'Misc.At' | translate }} {{ service.changes.at(-1).created_at | date: 'dd.MM.yyyy' }}
                    </td>
                </tr>
            </table>
            -->
        </div>

</clr-modal>
